if (!customElements.get('klaviyo-back-in-stock-form')) {
  const KLAVIYO_API_KEY = 'UuwBgV'; 
  const LIST_ID = 'SY3PqZ';
  /* 
  public key, safe to expose
  access within Klaviyo app at account > settings > API keys
  custom bis based off this support thread: 
  https://community.klaviyo.com/integrations-39/custom-back-in-stock-form-shopify-925 

  BIS Implementation: https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
  Client Subscription Implementation: https://developers.klaviyo.com/en/reference/create_client_subscription
  */
  class KlaviyoBISForm extends HTMLElement {
    constructor() {
      super();
      this.isComingSoon = this.dataset.comingSoon || false;
      this.comingSoonSuccess = this.dataset.comingSoonSuccess || '';
    }
    
    connectedCallback() {
      if (!this.isConnected) return;
      
      this.addEventListener('submit', (e) => {
        e.preventDefault();
        this.email = this.querySelector('[data-email-field]')?.value;
        
        this.closest('drawer-modal')?.classList.add('loading');
        this.postForm().then(() => {
          this.closest('drawer-modal')?.classList.remove('loading');
        });
      });
    }
    
    postForm = async() => {
      this.variantId = this.querySelector('[data-variant-selector]').value;
      this.consentToMarketing = this.querySelector('[data-marketing-consent-field]').checked 

      const data = {
        'type': 'back-in-stock-subscription',
        'attributes': {
            'profile': {
                'data': {
                    'type': 'profile',
                    'attributes': {
                        'email': `${this.email}`
                    }
                }
            },
            "channels": ["EMAIL"],
        },
        'relationships': {
            'variant': {
                'data': {
                    'type': 'catalog-variant',
                    'id': `$shopify:::$default:::${this.variantId}`
                }
            }
        }
    };

      await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_API_KEY}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-02-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({ data })
    }).then(res => {
      if (res.ok) {
        this.innerHTML = this.isComingSoon ?
         `<div class="block text-lg text-center font-semibold pb-10 text-primaryDark">${this.comingSoonSuccess}</div>` :
         `<div class="block text-lg text-center font-semibold pb-10 text-primaryDark">Thanks! We'll let you know when this item is back in stock.</div>`;
      }
    }).catch((err) => {
      this.innerHTML = `<div class="block text-lg text-center font-semibold text-primaryDark">Unable to add this item to your restock list.</div>`;
      console.error(err);
    });

    if (this.consentToMarketing) {
      const data = {
        'type': 'subscription',
        'attributes': {
          'profile': {
            'data': {
              'type': 'profile',
              'attributes': {
                'email': `${this.email}`
              }
            }
          },
        },
        'relationships': {
          'list': {
            'data': {
              'type': 'list',
              'id': `${LIST_ID}`
            }
          }
        }
      };

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-10-15', 
          'content-type': 'application/json'
        },
        body: JSON.stringify({ data })
      };
      
      fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_API_KEY}`, options)
        .then(res => res.json())
        .then(res => console.log(res))
        .catch(err => console.error(err));
    }
  }
}

customElements.define('klaviyo-back-in-stock-form', KlaviyoBISForm);
}